import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { StatusFlagsIndexResponse } from "./types/statusFlags/responses/StatusFlagsIndexResponse";
import { SuccessResponse } from "./types/common/responses/SuccessResponse";
import { UpdateFlagRequest } from "./types/statusFlags/requests/UpdateFlagRequest";
export const statusFlagsApi = createApi({
  reducerPath: "statusFlagsApi",
  baseQuery: DynamicBaseQuery,
  keepUnusedDataFor: 10,
  tagTypes: ["Flags"],
  endpoints: (builder) => ({
    getStatusFlagsIndex: builder.query<StatusFlagsIndexResponse, void>({
      query: () => ({
        url: "/status-flags",
        method: "GET",
      }),
      providesTags: ["Flags"],
    }),
    createStatusFlag: builder.mutation<SuccessResponse, FormData>({
      query: (body) => ({
        url: "/status-flags",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Flags"],
    }),
    updateStatusFlag: builder.mutation<
      SuccessResponse,
      { flag: number; body: UpdateFlagRequest }
    >({
      query: ({ flag, body }) => ({
        url: `/status-flags/${flag}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Flags"],
    }),
    updateFlagIcon: builder.mutation<
      SuccessResponse,
      { flag: number; body: FormData }
    >({
      query: ({ flag, body }) => ({
        url: `/status-flags/${flag}/icon`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Flags"],
    }),
    deleteStatusFlag: builder.mutation<SuccessResponse, { flag: number }>({
      query: ({ flag }) => ({
        url: `/status-flags/${flag}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Flags"],
    }),
  }),
});
export const {
  useGetStatusFlagsIndexQuery,
  useCreateStatusFlagMutation,
  useUpdateStatusFlagMutation,
  useUpdateFlagIconMutation,
  useDeleteStatusFlagMutation,
  usePrefetch,
} = statusFlagsApi;
